import ContentContainer from "components/ContentContainer";
import { IntersectionObserverOptions } from "hooks/useIntersectionObserver";
import useOnScreen from "hooks/useOnScreen";
import React, { useRef } from "react";
import MenuAndContacts from "./MenuAndContacts";
import { Container } from "./styles";
import TermsAndConditions from "./TermsAndConditions";
import WhereAreWe from "./WhereAreWe";

interface Props {
  className?: string;
  modulesURL?: string;
}

const intersectionOptions: IntersectionObserverOptions = {
  unobserveOnIntersection: true,
  threshold: 0.1,
};

const Footer: React.FC<Props> = ({ className, modulesURL }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const isOnScreen = useOnScreen(containerRef, intersectionOptions);

  return (
    <Container ref={containerRef} isOnScreen={isOnScreen} className={className}>
      <ContentContainer>
        <MenuAndContacts modulesURL={modulesURL} />
        <WhereAreWe />
        <TermsAndConditions />
      </ContentContainer>
    </Container>
  );
};

export default Footer;
